import React, { useState } from 'react';
import EventLogDetailTable from './eventLogDetailTable/EventLogDetailTable';
import EventLogDetailSearchBar from './eventLogDetailSearchBar/EventLogDetailSearchBar';

const EventLogDetail = () => {
  const [ data, setData ] = useState([]);
  const [ searchMap, setSearchMap ] = useState({
                                        dateValid: false,
                                        beginDate: new Date(),
                                        endDate: new Date(),
                                        moduleIdx: 0,
                                      })

  return(
    <section>
      <EventLogDetailSearchBar setData={setData}
                               searchMap={searchMap}
                               setSearchMap={setSearchMap} />
      <EventLogDetailTable data={data} setData={setData} searchMap={searchMap} />
    </section>
  )
}

export default EventLogDetail;